import React, { useEffect, useState } from "react";
import { Modal, Progress, Typography } from "antd";
import "./upiTimerModal.css";
import timer_worker_script from "../../../../web-workers/timerWorker";
import { formatOtpTime } from "../../../../Utils/utils";
import CustomButton from "../../../resuableComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { showFailedModal } from "../../../../slices/PaymentInitiationSlice";
import { startAutoRefund } from "../../../../slices/AutoRefundSlice";
import TranslateText from "../../../resuableComponents/TranslateText";
import { useTranslation } from "react-i18next";

const UpiTimerModal = ({ upiId, showTimer, callback }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const paymentInitiationData = useSelector((state) => state.paymentInitiation.paymentInitiationData);
  const defaultDuration = 300;
  const expiryDuration = paymentInitiationData?.actions?.[0]?.expirySec;
  const duration = expiryDuration || defaultDuration;
  const [countdown, setCountdown] = useState(duration);

  useEffect(() => {
    setCountdown(duration);
  }, [showTimer]);

  useEffect(() => {
    if (showTimer) {
      const timerWorker = new Worker(timer_worker_script);
      timerWorker.postMessage({ duration: duration });
      timerWorker.onmessage = async ({ data }) => {
        if (data === "done") {
          setCountdown(0);
          clearInterval(timerWorker);
          // With auto refund on, the auto refund loader verifies the payment before it is treated as failed.
          // The transaction is passed in, because callback() resets the payment.
          const autoRefund = dispatch(startAutoRefund(paymentInitiationData?.transactionId));
          callback();
          if (!(await autoRefund)) {
            dispatch(showFailedModal(true));
          }
        } else {
          setCountdown(data);
        }
      };
      if (!showTimer) {
        timerWorker.terminate();
      }
      return () => {
        timerWorker.terminate();
      };
    }
  }, [showTimer]);

  return (
    <Modal
      centered
      open={showTimer}
      footer={null}
      closable={false}
      style={{ padding: "24px" }}
    >
      <div className="upi-timer-modal-root">
        <div className="upi-timer-modal-header dynamic-font-family">
          <Typography><TranslateText label={"OPEN_UPI_APPLICATION"}>Open your UPI application and</TranslateText></Typography>
          <Typography><TranslateText label={"CONFIRM_PAYMENT_BEFORE_TIME"}>confirm the payment before the time expires</TranslateText></Typography>
        </div>
        <div className="upi-id-conatiner dynamic-font-family">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
          >
            <path
              d="M7.5088 11.8265L10.3173 1.92327L12.8449 6.95874L7.5088 11.8265Z"
              stroke="#2D2B32"
              strokeWidth="1.4"
            />
            <path
              d="M2.63481 11.8263L5.44323 1.9234L7.97049 6.95873L2.63481 11.8263Z"
              stroke="#2D2B32"
              strokeWidth="1.4"
            />
          </svg>
          <Typography>{upiId}</Typography>
        </div>
        <div className="upi-timer-modal-timer dynamic-font-family">
          <Typography className="modal-timer-expiry-font">
            <TranslateText label={"EXPIRES_IN"}>Expires in</TranslateText>
          </Typography>
          <Progress
            type="circle"
            percent={countdown && (countdown / duration) * 100}
            strokeColor={"#FAA4A4"}
            format={() => (
              <div className="timer-font dynamic-font-family">
                {" "}
                {formatOtpTime(countdown)}
              </div>
            )}
            size={140}
          />
        </div>
        <div className="upi-timer-modal-footer dynamic-font-family">
          <Typography>
            <TranslateText label={"TRANSACTION_COMPLETE_NOTE"}>
              Note: Kindly avoid using the back button until the transaction process is complete
            </TranslateText>

          </Typography>
        </div>
        <CustomButton
          text={t("CANCEL_PAYMENT")}
          buttonType={"primary-btn"}
          containerType={"link"}
          onClick={callback}
          block={true}
        />
      </div>
    </Modal>
  );
};

export default UpiTimerModal;
